import { useEffect, useRef } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PrivateImage } from "@/components/files/PrivateMedia";
import { cn } from "@/lib/utils";

function Citations({ message }) {
  const urls = [...new Set(message.citations || [])].filter((url) => /^https?:\/\//i.test(url));
  if (!urls.length) return null;
  return <ol className="mt-1 flex flex-wrap gap-1" data-testid={`chat-citations-${message.id}`}>
    {urls.map((url, number) => <li key={url}><a href={url} target="_blank" rel="noreferrer" title={url} data-testid={`chat-citation-${message.id}-${number + 1}`}
      className="inline-flex items-center gap-1 font-mono text-[9px] px-1.5 py-0.5 border border-jarvis-cyan/25 text-jarvis-cyan/80 hover:text-jarvis-cyanBright hover:border-jarvis-cyan/60 max-w-[180px] truncate">
      [{number + 1}] {url.replace(/^https?:\/\/(www\.)?/, "").split("/")[0]}</a></li>)}
  </ol>;
}

export function MessageList({ messages, busy }) {
  const scroll = useRef(null), reduced = useReducedMotion(), navigate = useNavigate();
  useEffect(() => { scroll.current?.scrollTo({ top: scroll.current.scrollHeight, behavior: reduced ? "instant" : "smooth" }); }, [messages, reduced]);
  return <div ref={scroll} className="flex-1 min-h-0 overflow-y-auto space-y-1.5 pr-1 font-code text-sm leading-relaxed" data-testid="conversation-log">
    <AnimatePresence initial={false}>{messages.map((message) => <motion.div key={message.id} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}
      className="flex gap-2" data-testid={`log-line-${message.id}`}>
      <span className={cn("shrink-0 font-mono text-[11px] uppercase tracking-[0.12em] pt-0.5 select-none", message.role === "user" ? "text-jarvis-amber" : "text-jarvis-cyan")}>{message.role === "user" ? "Daddy:" : "Jarvis:"}</span>
      <div className="min-w-0 flex-1"><span className="whitespace-pre-wrap text-slate-200">{message.content || (busy && message.role === "assistant" ? "▍" : "")}</span>
        {message.image && <button onClick={() => navigate("/files?tab=generated")} data-testid={`chat-generated-image-${message.id}`} title="Open in Files → Generated"
          className="mt-1.5 block border border-jarvis-purple/40 hud-chamfer overflow-hidden hover:border-jarvis-violet transition-colors shadow-[0_0_18px_rgba(118,88,255,0.25)]">
          <PrivateImage id={message.image.id} alt={message.image.prompt} className="max-h-44 w-auto object-contain" /></button>}
        <Citations message={message} />
      </div>
    </motion.div>)}</AnimatePresence>
  </div>;
}
